export default __webpack_public_path__ + "static/officeImage-44d701d491cf3b91c51108c247cccfeb.png";